(ns app.front.view.group.admin.fees.payment.payment-events
  (:require [app.front.entities :as entities]
            [clojure.string :as str]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx
  ::enable-online-payment
  (fn [_ [_ authority-group-id]]
    ;; FIXME: The management views will not update automatically.
    ;; User will only see the online payment option after reload
    {:comm/command {:command    :fee/enable-online-payment
                    :method     :post
                    :data       {:authority-group-id authority-group-id}
                    :on-success [::entities/apply-changes]}}))


(rf/reg-event-fx
  ::disable-online-payment
  (fn [_ [_ authority-group-id]]
    {:comm/command {:command    :fee/disable-online-payment
                    :method     :post
                    :data       {:authority-group-id authority-group-id}
                    :on-success [::entities/apply-changes]}}))


(rf/reg-event-fx
  ::update-payment-instructions
  (fn [_ [_ authority-group-id new-instructions]]
    {:comm/command {:command    :fee/edit-payment-instructions
                    :method     :post
                    :data       {:authority-group-id   authority-group-id
                                 :payment-instructions (str/trim new-instructions)}
                    :on-success [::entities/apply-changes]}}))


(rf/reg-event-fx
  ::save-payment-detail
  (fn [_ [_ authority-group-id payment-detail]]
    {:comm/command {:command    :fee/add-payment-detail
                    :method     :post
                    :data       (merge payment-detail {:authority-group-id authority-group-id})
                    :on-success [::entities/apply-changes]}}))


(rf/reg-event-fx
  ::update-payment-detail
  (fn [_ [_ authority-group-id payment-detail]]
    (let [payment-detail-id (:db/id payment-detail)
          cheque?           (not (:payment-detail/cheque? payment-detail))]
      {:comm/command {:command    :fee/update-payment-detail
                      :method     :post
                      :data       (util/mmap {:payment-detail/cheque? cheque?} authority-group-id payment-detail-id)
                      :on-success [::entities/apply-changes]}})))

(rf/reg-event-fx
  ::delete-payment-detail
  (fn [_ [_ authority-group-id payment-detail-id]]
    {:comm/command {:command    :fee/delete-payment-detail
                    :method     :post
                    :data       (util/mmap authority-group-id payment-detail-id)
                    :on-success [::entities/apply-changes]}}))
